$(window).load(function () {
  setTimeout(function () {
    $('.preloader').fadeOut('slow', function () { });
  }, 700);
});



// WEBPACK FOOTER //
// ./app/blocks/loader/loader.js